import React from 'react';
import { FloOpenFileIcon } from '@fmlx/icons';
import { FmlxLink } from 'fmlx-common-ui';
import { convertHexToRGBAString } from 'utils/Global';
import './RMLink.scss';

interface RMLinkProps {
  text: string;
  url: string;
  customColor?: string;
  id?: string;
  customIconSize?: number;
  customLinkSize?: FmlxLink.Size;
}

const DEFAULT_LINK_COLOR = '#006af5'; // Default color used by FmlxLink

export const RMLink = ({
  text,
  url,
  customColor,
  id,
  customIconSize,
  customLinkSize,
}: RMLinkProps) => {
  return (
    <span
      id={id ?? 'rmlink-wrapper'}
      className={`rmlink-wrapper`}
      style={
        customColor
          ? ({
              '--rmlink-custom-color': convertHexToRGBAString(customColor, 0.4),
            } as React.CSSProperties)
          : undefined
      }
    >
      <FmlxLink
        id={'rmlink-fmlxlink'}
        size={customLinkSize ?? FmlxLink.Size.LARGE}
        label={
          (
            <span
              id="rmlink-text"
              className={`rmlink-text ${customColor ? `text-[${customColor}]` : ''}`}
            >
              {text}
              <FloOpenFileIcon
                id="rmlink-icon"
                size="xs"
                customColor={customColor ?? DEFAULT_LINK_COLOR}
                className="ml-[2px] mb-[2px]"
                customSize={customIconSize}
              />
            </span>
          ) as any
        }
        onClick={(e) => {
          e.stopPropagation();
          window.open(url, '_blank', 'noopener,noreferrer');
        }}
      />
    </span>
  );
};
